webpackJsonp(["pages.groups.merge_requests"],{

/***/ "./filtered_search/filtered_search_manager.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// EXTERNAL MODULE: ./lib/utils/common_utils.js
var common_utils = __webpack_require__("./lib/utils/common_utils.js");

// EXTERNAL MODULE: ./lib/utils/url_utility.js
var url_utility = __webpack_require__("./lib/utils/url_utility.js");

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./filtered_search/container.js
var container = __webpack_require__("./filtered_search/container.js");

// EXTERNAL MODULE: ./filtered_search/filtered_search_token_keys.js
var filtered_search_token_keys = __webpack_require__("./filtered_search/filtered_search_token_keys.js");

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");

// CONCATENATED MODULE: ./filtered_search/event_hub.js


/* harmony default export */ var event_hub = (new vue_esm["a" /* default */]());
// EXTERNAL MODULE: ./filtered_search/filtered_search_tokenizer.js
var filtered_search_tokenizer = __webpack_require__("./filtered_search/filtered_search_tokenizer.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./filtered_search/components/recent_searches_dropdown_content.vue




/* harmony default export */ var recent_searches_dropdown_content = ({
  name: 'RecentSearchesDropdownContent',
  props: {
    items: {
      type: Array,
      required: true
    },
    isLocalStorageAvailable: {
      type: Boolean,
      required: false,
      default: true
    },
    allowedKeys: {
      type: Array,
      required: true
    }
  },
  computed: {
    processedItems: function processedItems() {
      var _this = this;

      return this.items.map(function (item) {
        var _FilteredSearchTokeni = filtered_search_tokenizer["a" /* default */].processTokens(item, _this.allowedKeys),
            tokens = _FilteredSearchTokeni.tokens,
            searchToken = _FilteredSearchTokeni.searchToken;

        var resultantTokens = tokens.map(function (token) {
          return {
            prefix: token.key + ':',
            suffix: '' + token.symbol + token.value
          };
        });

        return {
          text: item,
          tokens: resultantTokens,
          searchToken: searchToken
        };
      });
    },
    hasItems: function hasItems() {
      return this.items.length > 0;
    }
  },
  methods: {
    onItemActivated: function onItemActivated(text) {
      event_hub.$emit('recentSearchesItemSelected', text);
    },
    onRequestClearRecentSearches: function onRequestClearRecentSearches(e) {
      // Stop the dropdown from closing
      e.stopPropagation();

      event_hub.$emit('requestClearRecentSearches');
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21b166e4","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./filtered_search/components/recent_searches_dropdown_content.vue
var recent_searches_dropdown_content_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLocalStorageAvailable)?_c('div',{staticClass:"dropdown-info-note"},[_vm._v("\n    This feature requires local storage to be enabled\n  ")]):(_vm.hasItems)?_c('ul',[_vm._l((_vm.processedItems),function(item,index){return _c('li',{key:("processed-items-" + index)},[_c('button',{staticClass:"filtered-search-history-dropdown-item",attrs:{"type":"button"},on:{"click":function($event){_vm.onItemActivated(item.text)}}},[_c('span',_vm._l((item.tokens),function(token,index){return _c('span',{key:("dropdown-token-" + index),staticClass:"filtered-search-history-dropdown-token"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(token.prefix))]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(token.suffix))])])})),_vm._v(" "),_c('span',{staticClass:"filtered-search-history-dropdown-search-token"},[_vm._v("\n          "+_vm._s(item.searchToken)+"\n        ")])])])}),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('button',{staticClass:"filtered-search-history-clear-button",attrs:{"type":"button"},on:{"click":function($event){_vm.onRequestClearRecentSearches($event)}}},[_vm._v("\n        Clear recent searches\n      ")])])],2):_c('div',{staticClass:"dropdown-info-note"},[_vm._v("\n    You don't have any recent searches\n  ")])])}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./filtered_search/components/recent_searches_dropdown_content.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  recent_searches_dropdown_content,
  recent_searches_dropdown_content_render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_recent_searches_dropdown_content = (Component.exports);

// CONCATENATED MODULE: ./filtered_search/recent_searches_root.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var recent_searches_root_RecentSearchesRoot = function () {
  function RecentSearchesRoot(recentSearchesStore, recentSearchesService, wrapperElement) {
    _classCallCheck(this, RecentSearchesRoot);

    this.store = recentSearchesStore;
    this.service = recentSearchesService;
    this.wrapperElement = wrapperElement;
  }

  _createClass(RecentSearchesRoot, [{
    key: 'init',
    value: function init() {
      this.bindEvents();
      this.render();
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      this.onRequestClearRecentSearchesWrapper = this.onRequestClearRecentSearches.bind(this);

      event_hub.$on('requestClearRecentSearches', this.onRequestClearRecentSearchesWrapper);
    }
  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      event_hub.$off('requestClearRecentSearches', this.onRequestClearRecentSearchesWrapper);
    }
  }, {
    key: 'render',
    value: function render() {
      var state = this.store.state;
      this.vm = new vue_esm["a" /* default */]({
        el: this.wrapperElement,
        components: {
          RecentSearchesDropdownContent: components_recent_searches_dropdown_content
        },
        data: function data() {
          return state;
        },

        template: '\n        <recent-searches-dropdown-content\n          :items="recentSearches"\n          :is-local-storage-available="isLocalStorageAvailable"\n          :allowed-keys="allowedKeys"\n          />\n      '
      });
    }
  }, {
    key: 'onRequestClearRecentSearches',
    value: function onRequestClearRecentSearches() {
      var resultantSearches = this.store.setRecentSearches([]);
      this.service.save(resultantSearches);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.unbindEvents();
      if (this.vm) {
        this.vm.$destroy();
      }
    }
  }]);

  return RecentSearchesRoot;
}();

/* harmony default export */ var recent_searches_root = (recent_searches_root_RecentSearchesRoot);
// CONCATENATED MODULE: ./filtered_search/stores/recent_searches_store.js
var recent_searches_store__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function recent_searches_store__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var recent_searches_store_RecentSearchesStore = function () {
  function RecentSearchesStore() {
    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var allowedKeys = arguments[1];

    recent_searches_store__classCallCheck(this, RecentSearchesStore);

    this.state = Object.assign({
      isLocalStorageAvailable: true,
      recentSearches: [],
      allowedKeys: allowedKeys
    }, initialState);
  }

  recent_searches_store__createClass(RecentSearchesStore, [{
    key: 'addRecentSearch',
    value: function addRecentSearch(newSearch) {
      this.setRecentSearches([newSearch].concat(this.state.recentSearches));

      return this.state.recentSearches;
    }
  }, {
    key: 'setRecentSearches',
    value: function setRecentSearches() {
      var searches = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var trimmedSearches = searches.map(function (search) {
        return search.trim();
      });
      this.state.recentSearches = underscore_default.a.uniq(trimmedSearches).slice(0, 5);
      return this.state.recentSearches;
    }
  }]);

  return RecentSearchesStore;
}();

/* harmony default export */ var recent_searches_store = (recent_searches_store_RecentSearchesStore);
// CONCATENATED MODULE: ./filtered_search/services/recent_searches_service_error.js
function recent_searches_service_error__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecentSearchesServiceError = function RecentSearchesServiceError(message) {
  recent_searches_service_error__classCallCheck(this, RecentSearchesServiceError);

  this.name = 'RecentSearchesServiceError';
  this.message = message || 'Recent Searches Service is unavailable';
};

// Can't use `extends` for builtin prototypes and get true inheritance yet


RecentSearchesServiceError.prototype = Error.prototype;

/* harmony default export */ var recent_searches_service_error = (RecentSearchesServiceError);
// EXTERNAL MODULE: ./lib/utils/accessor.js
var accessor = __webpack_require__("./lib/utils/accessor.js");

// CONCATENATED MODULE: ./filtered_search/services/recent_searches_service.js
var recent_searches_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function recent_searches_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var recent_searches_service_RecentSearchesService = function () {
  function RecentSearchesService() {
    var localStorageKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'issuable-recent-searches';

    recent_searches_service__classCallCheck(this, RecentSearchesService);

    this.localStorageKey = localStorageKey;
  }

  recent_searches_service__createClass(RecentSearchesService, [{
    key: 'fetch',
    value: function fetch() {
      if (!RecentSearchesService.isAvailable()) {
        var error = new recent_searches_service_error();
        return Promise.reject(error);
      }

      var input = window.localStorage.getItem(this.localStorageKey);

      var searches = [];
      if (input && input.length > 0) {
        try {
          searches = JSON.parse(input);
        } catch (err) {
          return Promise.reject(err);
        }
      }

      return Promise.resolve(searches);
    }
  }, {
    key: 'save',
    value: function save() {
      var searches = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (!RecentSearchesService.isAvailable()) return;

      window.localStorage.setItem(this.localStorageKey, JSON.stringify(searches));
    }
  }], [{
    key: 'isAvailable',
    value: function isAvailable() {
      return accessor["a" /* default */].isLocalStorageAccessSafe();
    }
  }]);

  return RecentSearchesService;
}();

/* harmony default export */ var recent_searches_service = (recent_searches_service_RecentSearchesService);
// EXTERNAL MODULE: ./lib/utils/dom_utils.js
var dom_utils = __webpack_require__("./lib/utils/dom_utils.js");

// EXTERNAL MODULE: ./filtered_search/filtered_search_dropdown_manager.js + 8 modules
var filtered_search_dropdown_manager = __webpack_require__("./filtered_search/filtered_search_dropdown_manager.js");

// EXTERNAL MODULE: ./filtered_search/filtered_search_visual_tokens.js + 1 modules
var filtered_search_visual_tokens = __webpack_require__("./filtered_search/filtered_search_visual_tokens.js");

// EXTERNAL MODULE: ./filtered_search/dropdown_utils.js
var dropdown_utils = __webpack_require__("./filtered_search/dropdown_utils.js");

// CONCATENATED MODULE: ./filtered_search/filtered_search_manager.js
var filtered_search_manager__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function filtered_search_manager__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

















var filtered_search_manager_FilteredSearchManager = function () {
  function FilteredSearchManager(_ref) {
    var page = _ref.page,
        _ref$isGroup = _ref.isGroup,
        isGroup = _ref$isGroup === undefined ? false : _ref$isGroup,
        _ref$isGroupAncestor = _ref.isGroupAncestor,
        isGroupAncestor = _ref$isGroupAncestor === undefined ? false : _ref$isGroupAncestor,
        _ref$isGroupDecendent = _ref.isGroupDecendent,
        isGroupDecendent = _ref$isGroupDecendent === undefined ? false : _ref$isGroupDecendent,
        _ref$filteredSearchTo = _ref.filteredSearchTokenKeys,
        filteredSearchTokenKeys = _ref$filteredSearchTo === undefined ? filtered_search_token_keys["a" /* default */] : _ref$filteredSearchTo,
        _ref$stateFiltersSele = _ref.stateFiltersSelector,
        stateFiltersSelector = _ref$stateFiltersSele === undefined ? '.issues-state-filters' : _ref$stateFiltersSele;

    filtered_search_manager__classCallCheck(this, FilteredSearchManager);

    this.isGroup = isGroup;
    this.isGroupAncestor = isGroupAncestor;
    this.isGroupDecendent = isGroupDecendent;
    this.states = ['opened', 'closed', 'merged', 'all'];

    this.page = page;
    this.container = container["a" /* default */].container;
    this.filteredSearchInput = this.container.querySelector('.filtered-search');
    this.filteredSearchInputForm = this.filteredSearchInput.form;
    this.clearSearchButton = this.container.querySelector('.clear-search');
    this.tokensContainer = this.container.querySelector('.tokens-container');
    this.filteredSearchTokenKeys = filteredSearchTokenKeys;
    this.stateFiltersSelector = stateFiltersSelector;
    this.recentsStorageKeyNames = {
      issues: 'issue-recent-searches',
      merge_requests: 'merge-request-recent-searches'
    };

    this.recentSearchesStore = new recent_searches_store({
      isLocalStorageAvailable: recent_searches_service.isAvailable(),
      allowedKeys: this.filteredSearchTokenKeys.getKeys()
    });
    this.searchHistoryDropdownElement = document.querySelector('.js-filtered-search-history-dropdown');
    var fullPath = this.searchHistoryDropdownElement ? this.searchHistoryDropdownElement.dataset.fullPath : 'project';
    var recentSearchesKey = fullPath + '-' + this.recentsStorageKeyNames[this.page];
    this.recentSearchesService = new recent_searches_service(recentSearchesKey);
  }

  filtered_search_manager__createClass(FilteredSearchManager, [{
    key: 'setup',
    value: function setup() {
      var _this = this;

      // Fetch recent searches from localStorage
      this.fetchingRecentSearchesPromise = this.recentSearchesService.fetch().catch(function (error) {
        if (error.name === 'RecentSearchesServiceError') return undefined;
        // eslint-disable-next-line no-new
        new flash["a" /* default */]('An error occurred while parsing recent searches');
        // Gracefully fail to empty array
        return [];
      }).then(function (searches) {
        if (!searches) {
          return;
        }

        // Put any searches that may have come in before
        // we fetched the saved searches ahead of the already saved ones
        var resultantSearches = _this.recentSearchesStore.setRecentSearches(_this.recentSearchesStore.state.recentSearches.concat(searches));
        _this.recentSearchesService.save(resultantSearches);
      });

      if (this.filteredSearchInput) {
        this.tokenizer = filtered_search_tokenizer["a" /* default */];
        this.dropdownManager = new filtered_search_dropdown_manager["a" /* default */]({
          baseEndpoint: this.filteredSearchInput.getAttribute('data-base-endpoint') || '',
          tokenizer: this.tokenizer,
          page: this.page,
          isGroup: this.isGroup,
          isGroupAncestor: this.isGroupAncestor,
          filteredSearchTokenKeys: this.filteredSearchTokenKeys
        });

        this.recentSearchesRoot = new recent_searches_root(this.recentSearchesStore, this.recentSearchesService, this.searchHistoryDropdownElement);
        this.recentSearchesRoot.init();

        this.bindEvents();
        this.loadSearchParamsFromURL();
        this.dropdownManager.setDropdown();
        this.cleanupWrapper = this.cleanup.bind(this);
        document.addEventListener('beforeunload', this.cleanupWrapper);
      }
    }
  }, {
    key: 'cleanup',
    value: function cleanup() {
      this.unbindEvents();
      document.removeEventListener('beforeunload', this.cleanupWrapper);

      if (this.recentSearchesRoot) {
        this.recentSearchesRoot.destroy();
      }
    }
  }, {
    key: 'bindStateEvents',
    value: function bindStateEvents() {
      var _this2 = this;

      this.stateFilters = document.querySelector('.container-fluid ' + this.stateFiltersSelector);

      if (this.stateFilters) {
        this.searchStateWrapper = this.searchState.bind(this);

        this.applyToStateFilters(function (filterEl) {
          filterEl.addEventListener('click', _this2.searchStateWrapper);
        });
      }
    }
  }, {
    key: 'unbindStateEvents',
    value: function unbindStateEvents() {
      var _this3 = this;

      if (this.stateFilters) {
        this.applyToStateFilters(function (filterEl) {
          filterEl.removeEventListener('click', _this3.searchStateWrapper);
        });
      }
    }
  }, {
    key: 'applyToStateFilters',
    value: function applyToStateFilters(callback) {
      var _this4 = this;

      this.stateFilters.querySelectorAll('a[data-state]').forEach(function (filterEl) {
        if (_this4.states.indexOf(filterEl.dataset.state) > -1) {
          callback(filterEl);
        }
      });
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      this.handleFormSubmit = this.handleFormSubmit.bind(this);
      this.setDropdownWrapper = this.dropdownManager.setDropdown.bind(this.dropdownManager);
      this.toggleClearSearchButtonWrapper = this.toggleClearSearchButton.bind(this);
      this.handleInputPlaceholderWrapper = this.handleInputPlaceholder.bind(this);
      this.handleInputVisualTokenWrapper = this.handleInputVisualToken.bind(this);
      this.checkForEnterWrapper = this.checkForEnter.bind(this);
      this.onClearSearchWrapper = this.onClearSearch.bind(this);
      this.checkForBackspaceWrapper = this.checkForBackspace.call(this);
      this.removeSelectedTokenKeydownWrapper = this.removeSelectedTokenKeydown.bind(this);
      this.unselectEditTokensWrapper = this.unselectEditTokens.bind(this);
      this.editTokenWrapper = this.editToken.bind(this);
      this.tokenChange = this.tokenChange.bind(this);
      this.addInputContainerFocusWrapper = this.addInputContainerFocus.bind(this);
      this.removeInputContainerFocusWrapper = this.removeInputContainerFocus.bind(this);
      this.onrecentSearchesItemSelectedWrapper = this.onrecentSearchesItemSelected.bind(this);
      this.removeTokenWrapper = this.removeToken.bind(this);

      this.filteredSearchInputForm.addEventListener('submit', this.handleFormSubmit);
      this.filteredSearchInput.addEventListener('input', this.setDropdownWrapper);
      this.filteredSearchInput.addEventListener('input', this.toggleClearSearchButtonWrapper);
      this.filteredSearchInput.addEventListener('input', this.handleInputPlaceholderWrapper);
      this.filteredSearchInput.addEventListener('input', this.handleInputVisualTokenWrapper);
      this.filteredSearchInput.addEventListener('keydown', this.checkForEnterWrapper);
      this.filteredSearchInput.addEventListener('keyup', this.checkForBackspaceWrapper);
      this.filteredSearchInput.addEventListener('click', this.tokenChange);
      this.filteredSearchInput.addEventListener('keyup', this.tokenChange);
      this.filteredSearchInput.addEventListener('focus', this.addInputContainerFocusWrapper);
      this.tokensContainer.addEventListener('click', this.removeTokenWrapper);
      this.tokensContainer.addEventListener('click', this.editTokenWrapper);
      this.clearSearchButton.addEventListener('click', this.onClearSearchWrapper);
      document.addEventListener('click', this.unselectEditTokensWrapper);
      document.addEventListener('click', this.removeInputContainerFocusWrapper);
      document.addEventListener('keydown', this.removeSelectedTokenKeydownWrapper);
      event_hub.$on('recentSearchesItemSelected', this.onrecentSearchesItemSelectedWrapper);

      this.bindStateEvents();
    }
  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      this.filteredSearchInputForm.removeEventListener('submit', this.handleFormSubmit);
      this.filteredSearchInput.removeEventListener('input', this.setDropdownWrapper);
      this.filteredSearchInput.removeEventListener('input', this.toggleClearSearchButtonWrapper);
      this.filteredSearchInput.removeEventListener('input', this.handleInputPlaceholderWrapper);
      this.filteredSearchInput.removeEventListener('input', this.handleInputVisualTokenWrapper);
      this.filteredSearchInput.removeEventListener('keydown', this.checkForEnterWrapper);
      this.filteredSearchInput.removeEventListener('keyup', this.checkForBackspaceWrapper);
      this.filteredSearchInput.removeEventListener('click', this.tokenChange);
      this.filteredSearchInput.removeEventListener('keyup', this.tokenChange);
      this.filteredSearchInput.removeEventListener('focus', this.addInputContainerFocusWrapper);
      this.tokensContainer.removeEventListener('click', this.removeTokenWrapper);
      this.tokensContainer.removeEventListener('click', this.editTokenWrapper);
      this.clearSearchButton.removeEventListener('click', this.onClearSearchWrapper);
      document.removeEventListener('click', this.unselectEditTokensWrapper);
      document.removeEventListener('click', this.removeInputContainerFocusWrapper);
      document.removeEventListener('keydown', this.removeSelectedTokenKeydownWrapper);
      event_hub.$off('recentSearchesItemSelected', this.onrecentSearchesItemSelectedWrapper);

      this.unbindStateEvents();
    }
  }, {
    key: 'checkForBackspace',
    value: function checkForBackspace() {
      var _this5 = this;

      var backspaceCount = 0;

      // closure for keeping track of the number of backspace keystrokes
      return function (e) {
        // 8 = Backspace Key
        // 46 = Delete Key
        if (e.keyCode === 8 || e.keyCode === 46) {
          var _FilteredSearchVisual = filtered_search_visual_tokens["a" /* default */].getLastVisualTokenBeforeInput(),
              lastVisualToken = _FilteredSearchVisual.lastVisualToken;

          var _DropdownUtils$getVis = dropdown_utils["a" /* default */].getVisualTokenValues(lastVisualToken),
              tokenName = _DropdownUtils$getVis.tokenName,
              tokenValue = _DropdownUtils$getVis.tokenValue;

          var canEdit = tokenName && _this5.canEdit && _this5.canEdit(tokenName, tokenValue);

          if (_this5.filteredSearchInput.value === '' && lastVisualToken && canEdit) {
            backspaceCount += 1;

            if (backspaceCount === 2) {
              backspaceCount = 0;
              _this5.filteredSearchInput.value = filtered_search_visual_tokens["a" /* default */].getLastTokenPartial();
              filtered_search_visual_tokens["a" /* default */].removeLastTokenPartial();
            }
          }

          // Reposition dropdown so that it is aligned with cursor
          _this5.dropdownManager.updateCurrentDropdownOffset();
        } else {
          backspaceCount = 0;
        }
      };
    }
  }, {
    key: 'checkForEnter',
    value: function checkForEnter(e) {
      if (e.keyCode === 38 || e.keyCode === 40) {
        var selectionStart = this.filteredSearchInput.selectionStart;

        e.preventDefault();
        this.filteredSearchInput.setSelectionRange(selectionStart, selectionStart);
      }

      if (e.keyCode === 13) {
        var dropdown = this.dropdownManager.mapping[this.dropdownManager.currentDropdown];
        var dropdownEl = dropdown.element;
        var activeElements = dropdownEl.querySelectorAll('.droplab-item-active');

        e.preventDefault();

        if (!activeElements.length) {
          if (this.isHandledAsync) {
            e.stopImmediatePropagation();

            this.filteredSearchInput.blur();
            this.dropdownManager.resetDropdowns();
          } else {
            // Prevent droplab from opening dropdown
            this.dropdownManager.destroyDroplab();
          }

          this.search();
        }
      }
    }
  }, {
    key: 'addInputContainerFocus',
    value: function addInputContainerFocus() {
      Object(dom_utils["a" /* addClassIfElementExists */])(this.filteredSearchInput.closest('.filtered-search-box'), 'focus');
    }
  }, {
    key: 'removeInputContainerFocus',
    value: function removeInputContainerFocus(e) {
      var inputContainer = this.filteredSearchInput.closest('.filtered-search-box');
      var isElementInFilteredSearch = inputContainer && inputContainer.contains(e.target);
      var isElementInDynamicFilterDropdown = e.target.closest('.filter-dropdown') !== null;
      var isElementInStaticFilterDropdown = e.target.closest('ul[data-dropdown]') !== null;

      if (!isElementInFilteredSearch && !isElementInDynamicFilterDropdown && !isElementInStaticFilterDropdown && inputContainer) {
        inputContainer.classList.remove('focus');
      }
    }
  }, {
    key: 'removeToken',
    value: function removeToken(e) {
      var removeButtonSelected = e.target.closest('.remove-token');

      if (removeButtonSelected) {
        e.preventDefault();
        // Prevent editToken from being triggered after token is removed
        e.stopImmediatePropagation();

        var button = e.target.closest('.selectable');
        filtered_search_visual_tokens["a" /* default */].selectToken(button, true);
        this.removeSelectedToken();
      }
    }
  }, {
    key: 'unselectEditTokens',
    value: function unselectEditTokens(e) {
      var inputContainer = this.container.querySelector('.filtered-search-box');
      var isElementInFilteredSearch = inputContainer && inputContainer.contains(e.target);
      var isElementInFilterDropdown = e.target.closest('.filter-dropdown') !== null;
      var isElementTokensContainer = e.target.classList.contains('tokens-container');

      if (!isElementInFilteredSearch && !isElementInFilterDropdown || isElementTokensContainer) {
        filtered_search_visual_tokens["a" /* default */].moveInputToTheRight();
        this.dropdownManager.resetDropdowns();
      }
    }
  }, {
    key: 'editToken',
    value: function editToken(e) {
      var token = e.target.closest('.js-visual-token');
      var sanitizedTokenName = token && token.querySelector('.name').textContent.trim();
      var canEdit = this.canEdit && this.canEdit(sanitizedTokenName);

      if (token && canEdit) {
        e.preventDefault();
        e.stopPropagation();
        filtered_search_visual_tokens["a" /* default */].editToken(token);
        this.tokenChange();
      }
    }
  }, {
    key: 'toggleClearSearchButton',
    value: function toggleClearSearchButton() {
      var query = dropdown_utils["a" /* default */].getSearchQuery();
      var hidden = 'hidden';
      var hasHidden = this.clearSearchButton.classList.contains(hidden);

      if (query.length === 0 && !hasHidden) {
        this.clearSearchButton.classList.add(hidden);
      } else if (query.length && hasHidden) {
        this.clearSearchButton.classList.remove(hidden);
      }
    }
  }, {
    key: 'handleInputPlaceholder',
    value: function handleInputPlaceholder() {
      var query = dropdown_utils["a" /* default */].getSearchQuery();
      var placeholder = 'Search or filter results...';
      var currentPlaceholder = this.filteredSearchInput.placeholder;

      if (query.length === 0 && currentPlaceholder !== placeholder) {
        this.filteredSearchInput.placeholder = placeholder;
      } else if (query.length > 0 && currentPlaceholder !== '') {
        this.filteredSearchInput.placeholder = '';
      }
    }
  }, {
    key: 'removeSelectedTokenKeydown',
    value: function removeSelectedTokenKeydown(e) {
      // 8 = Backspace Key
      // 46 = Delete Key
      if (e.keyCode === 8 || e.keyCode === 46) {
        this.removeSelectedToken();
      }
    }
  }, {
    key: 'removeSelectedToken',
    value: function removeSelectedToken() {
      filtered_search_visual_tokens["a" /* default */].removeSelectedToken();
      this.handleInputPlaceholder();
      this.toggleClearSearchButton();
      this.dropdownManager.updateCurrentDropdownOffset();
    }
  }, {
    key: 'onClearSearch',
    value: function onClearSearch(e) {
      e.preventDefault();
      this.clearSearch();
    }
  }, {
    key: 'clearSearch',
    value: function clearSearch() {
      var _this6 = this;

      this.filteredSearchInput.value = '';

      var removeElements = [];

      [].forEach.call(this.tokensContainer.children, function (t) {
        var canClearToken = t.classList.contains('js-visual-token');

        if (canClearToken) {
          var _DropdownUtils$getVis2 = dropdown_utils["a" /* default */].getVisualTokenValues(t),
              tokenName = _DropdownUtils$getVis2.tokenName,
              tokenValue = _DropdownUtils$getVis2.tokenValue;

          canClearToken = _this6.canEdit && _this6.canEdit(tokenName, tokenValue);
        }

        if (canClearToken) {
          removeElements.push(t);
        }
      });

      removeElements.forEach(function (el) {
        el.parentElement.removeChild(el);
      });

      this.clearSearchButton.classList.add('hidden');
      this.handleInputPlaceholder();

      this.dropdownManager.resetDropdowns();

      if (this.isHandledAsync) {
        this.search();
      }
    }
  }, {
    key: 'handleInputVisualToken',
    value: function handleInputVisualToken() {
      var input = this.filteredSearchInput;

      var _tokenizer$processTok = this.tokenizer.processTokens(input.value, this.filteredSearchTokenKeys.getKeys()),
          tokens = _tokenizer$processTok.tokens,
          searchToken = _tokenizer$processTok.searchToken;

      var _FilteredSearchVisual2 = filtered_search_visual_tokens["a" /* default */].getLastVisualTokenBeforeInput(),
          isLastVisualTokenValid = _FilteredSearchVisual2.isLastVisualTokenValid;

      if (isLastVisualTokenValid) {
        tokens.forEach(function (t) {
          input.value = input.value.replace(t.key + ':' + t.symbol + t.value, '');
          filtered_search_visual_tokens["a" /* default */].addFilterVisualToken(t.key, '' + t.symbol + t.value);
        });

        var fragments = searchToken.split(':');
        if (fragments.length > 1) {
          var inputValues = fragments[0].split(' ');
          var tokenKey = underscore_default.a.last(inputValues);

          if (inputValues.length > 1) {
            inputValues.pop();
            var searchTerms = inputValues.join(' ');

            input.value = input.value.replace(searchTerms, '');
            filtered_search_visual_tokens["a" /* default */].addSearchVisualToken(searchTerms);
          }

          filtered_search_visual_tokens["a" /* default */].addFilterVisualToken(tokenKey);
          input.value = input.value.replace(tokenKey + ':', '');
        }
      } else {
        // Keep listening to token until we determine that the user is done typing the token value
        var valueCompletedRegex = /([~%@]{0,1}".+")|([~%@]{0,1}'.+')|^((?![~%@]')(?![~%@]")(?!')(?!")).*/g;

        if (searchToken.match(valueCompletedRegex) && input.value[input.value.length - 1] === ' ') {
          filtered_search_visual_tokens["a" /* default */].addFilterVisualToken(searchToken);

          // Trim the last space as seen in the if statement above
          input.value = input.value.replace(searchToken, '').trim();
        }
      }
    }
  }, {
    key: 'handleFormSubmit',
    value: function handleFormSubmit(e) {
      e.preventDefault();
      this.search();
    }
  }, {
    key: 'saveCurrentSearchQuery',
    value: function saveCurrentSearchQuery() {
      var _this7 = this;

      // Don't save before we have fetched the already saved searches
      this.fetchingRecentSearchesPromise.then(function () {
        var searchQuery = dropdown_utils["a" /* default */].getSearchQuery();
        if (searchQuery.length > 0) {
          var resultantSearches = _this7.recentSearchesStore.addRecentSearch(searchQuery);
          _this7.recentSearchesService.save(resultantSearches);
        }
      }).catch(function () {
        // https://gitlab.com/gitlab-org/gitlab-ce/issues/30821
      });
    }

    // allows for modifying params array when a param can't be included in the URL (e.g. Service Desk)

  }, {
    key: 'getAllParams',
    value: function getAllParams(urlParams) {
      return this.modifyUrlParams ? this.modifyUrlParams(urlParams) : urlParams;
    }
  }, {
    key: 'loadSearchParamsFromURL',
    value: function loadSearchParamsFromURL() {
      var _this8 = this;

      var urlParams = Object(common_utils["l" /* getUrlParamsArray */])();
      var params = this.getAllParams(urlParams);
      var usernameParams = this.getUsernameParams();
      var hasFilteredSearch = false;

      params.forEach(function (p) {
        var split = p.split('=');
        var keyParam = decodeURIComponent(split[0]);
        var value = split[1];

        // Check if it matches edge conditions listed in this.filteredSearchTokenKeys
        var condition = _this8.filteredSearchTokenKeys.searchByConditionUrl(p);

        if (condition) {
          hasFilteredSearch = true;
          var canEdit = _this8.canEdit && _this8.canEdit(condition.tokenKey);
          filtered_search_visual_tokens["a" /* default */].addFilterVisualToken(condition.tokenKey, condition.value, canEdit);
        } else {
          // Sanitize value since URL converts spaces into +
          // Replace before decode so that we know what was originally + versus the encoded +
          var sanitizedValue = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : value;
          var match = _this8.filteredSearchTokenKeys.searchByKeyParam(keyParam);

          if (match) {
            // Use lastIndexOf because the token key is allowed to contain underscore
            // e.g. 'my_reaction' is the token key of 'my_reaction_emoji'
            var lastIndexOf = keyParam.lastIndexOf('_');
            var sanitizedKey = lastIndexOf !== -1 ? keyParam.slice(0, lastIndexOf) : keyParam;
            // Replace underscore with hyphen in the sanitizedkey.
            // e.g. 'my_reaction' => 'my-reaction'
            sanitizedKey = sanitizedKey.replace('_', '-');
            var symbol = match.symbol;
            var quotationsToUse = '';

            if (sanitizedValue.indexOf(' ') !== -1) {
              // Prefer ", but use ' if required
              quotationsToUse = sanitizedValue.indexOf('"') === -1 ? '"' : '\'';
            }

            hasFilteredSearch = true;
            var _canEdit = _this8.canEdit && _this8.canEdit(sanitizedKey, sanitizedValue);
            filtered_search_visual_tokens["a" /* default */].addFilterVisualToken(sanitizedKey, '' + symbol + quotationsToUse + sanitizedValue + quotationsToUse, _canEdit);
          } else if (!match && keyParam === 'assignee_id') {
            var id = parseInt(value, 10);
            if (usernameParams[id]) {
              hasFilteredSearch = true;
              var tokenName = 'assignee';
              var _canEdit2 = _this8.canEdit && _this8.canEdit(tokenName);
              filtered_search_visual_tokens["a" /* default */].addFilterVisualToken(tokenName, '@' + usernameParams[id], _canEdit2);
            }
          } else if (!match && keyParam === 'author_id') {
            var _id = parseInt(value, 10);
            if (usernameParams[_id]) {
              hasFilteredSearch = true;
              var _tokenName = 'author';
              var _canEdit3 = _this8.canEdit && _this8.canEdit(_tokenName);
              filtered_search_visual_tokens["a" /* default */].addFilterVisualToken(_tokenName, '@' + usernameParams[_id], _canEdit3);
            }
          } else if (!match && keyParam === 'search') {
            hasFilteredSearch = true;
            _this8.filteredSearchInput.value = sanitizedValue;
          }
        }
      });

      this.saveCurrentSearchQuery();

      if (hasFilteredSearch) {
        this.clearSearchButton.classList.remove('hidden');
        this.handleInputPlaceholder();
      }
    }
  }, {
    key: 'searchState',
    value: function searchState(e) {
      e.preventDefault();
      var target = e.currentTarget;
      // remove focus outline after click
      target.blur();

      var state = target.dataset && target.dataset.state;

      if (state) {
        this.search(state);
      }
    }
  }, {
    key: 'search',
    value: function search() {
      var _this9 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var paths = [];
      var searchQuery = dropdown_utils["a" /* default */].getSearchQuery();

      this.saveCurrentSearchQuery();

      var _tokenizer$processTok2 = this.tokenizer.processTokens(searchQuery, this.filteredSearchTokenKeys.getKeys()),
          tokens = _tokenizer$processTok2.tokens,
          searchToken = _tokenizer$processTok2.searchToken;

      var currentState = state || Object(common_utils["i" /* getParameterByName */])('state') || 'opened';
      paths.push('state=' + currentState);

      tokens.forEach(function (token) {
        var condition = _this9.filteredSearchTokenKeys.searchByConditionKeyValue(token.key, token.value.toLowerCase());

        var _ref2 = _this9.filteredSearchTokenKeys.searchByKey(token.key) || {},
            param = _ref2.param;
        // Replace hyphen with underscore to use as request parameter
        // e.g. 'my-reaction' => 'my_reaction'


        var underscoredKey = token.key.replace('-', '_');
        var keyParam = param ? underscoredKey + '_' + param : underscoredKey;
        var tokenPath = '';

        if (condition) {
          tokenPath = condition.url;
        } else {
          var tokenValue = token.value;

          if (tokenValue[0] === '\'' && tokenValue[tokenValue.length - 1] === '\'' || tokenValue[0] === '"' && tokenValue[tokenValue.length - 1] === '"') {
            tokenValue = tokenValue.slice(1, tokenValue.length - 1);
          }

          tokenPath = keyParam + '=' + encodeURIComponent(tokenValue);
        }

        paths.push(tokenPath);
      });

      if (searchToken) {
        var sanitized = searchToken.split(' ').map(function (t) {
          return encodeURIComponent(t);
        }).join('+');
        paths.push('search=' + sanitized);
      }

      var parameterizedUrl = '?scope=all&utf8=%E2%9C%93&' + paths.join('&');

      if (this.updateObject) {
        this.updateObject(parameterizedUrl);
      } else {
        Object(url_utility["g" /* visitUrl */])(parameterizedUrl);
      }
    }
  }, {
    key: 'getUsernameParams',
    value: function getUsernameParams() {
      var usernamesById = {};
      try {
        var attribute = this.filteredSearchInput.getAttribute('data-username-params');
        JSON.parse(attribute).forEach(function (user) {
          usernamesById[user.id] = user.username;
        });
      } catch (e) {
        // do nothing
      }
      return usernamesById;
    }
  }, {
    key: 'tokenChange',
    value: function tokenChange() {
      var dropdown = this.dropdownManager.mapping[this.dropdownManager.currentDropdown];

      if (dropdown) {
        var currentDropdownRef = dropdown.reference;

        this.setDropdownWrapper();
        currentDropdownRef.dispatchInputEvent();
      }
    }
  }, {
    key: 'onrecentSearchesItemSelected',
    value: function onrecentSearchesItemSelected(text) {
      this.clearSearch();
      this.filteredSearchInput.value = text;
      this.filteredSearchInput.dispatchEvent(new CustomEvent('input'));
      this.search();
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'canEdit',
    value: function canEdit() {
      return true;
    }
  }]);

  return FilteredSearchManager;
}();

/* harmony default export */ var filtered_search_manager = __webpack_exports__["a"] = (filtered_search_manager_FilteredSearchManager);

/***/ }),

/***/ "./pages/constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILTERED_SEARCH; });
/* eslint-disable import/prefer-default-export  */

var FILTERED_SEARCH = {
  MERGE_REQUESTS: 'merge_requests',
  ISSUES: 'issues'
};

/***/ }),

/***/ "./pages/groups/merge_requests/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__project_select__ = __webpack_require__("./project_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_search_init_filtered_search__ = __webpack_require__("./pages/search/init_filtered_search.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_constants__ = __webpack_require__("./pages/constants.js");




document.addEventListener('DOMContentLoaded', function () {
  Object(__WEBPACK_IMPORTED_MODULE_1__pages_search_init_filtered_search__["a" /* default */])({
    page: __WEBPACK_IMPORTED_MODULE_2__pages_constants__["a" /* FILTERED_SEARCH */].MERGE_REQUESTS
  });
  Object(__WEBPACK_IMPORTED_MODULE_0__project_select__["a" /* default */])();
});

/***/ }),

/***/ "./pages/search/init_filtered_search.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filtered_search_filtered_search_manager__ = __webpack_require__("./filtered_search/filtered_search_manager.js");


/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var page = _ref.page,
      filteredSearchTokenKeys = _ref.filteredSearchTokenKeys,
      isGroup = _ref.isGroup,
      isGroupAncestor = _ref.isGroupAncestor,
      isGroupDecendent = _ref.isGroupDecendent,
      stateFiltersSelector = _ref.stateFiltersSelector;

  var filteredSearchEnabled = __WEBPACK_IMPORTED_MODULE_0__filtered_search_filtered_search_manager__["a" /* default */] && document.querySelector('.filtered-search');
  if (filteredSearchEnabled) {
    var filteredSearchManager = new __WEBPACK_IMPORTED_MODULE_0__filtered_search_filtered_search_manager__["a" /* default */]({
      page: page,
      isGroup: isGroup,
      isGroupAncestor: isGroupAncestor,
      isGroupDecendent: isGroupDecendent,
      filteredSearchTokenKeys: filteredSearchTokenKeys,
      stateFiltersSelector: stateFiltersSelector
    });
    filteredSearchManager.setup();
  }
});

/***/ }),

/***/ "./project_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["a"] = projectSelect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__project_select_combo_button__ = __webpack_require__("./project_select_combo_button.js");
/* eslint-disable func-names, space-before-function-paren, wrap-iife, prefer-arrow-callback, no-var, comma-dangle, object-shorthand, one-var, one-var-declaration-per-line, no-else-return, quotes, max-len */



function projectSelect() {
  $('.ajax-project-select').each(function (i, select) {
    var placeholder;
    var simpleFilter = $(select).data('simpleFilter') || false;
    this.groupId = $(select).data('groupId');
    this.includeGroups = $(select).data('includeGroups');
    this.allProjects = $(select).data('allProjects') || false;
    this.orderBy = $(select).data('orderBy') || 'id';
    this.withIssuesEnabled = $(select).data('withIssuesEnabled');
    this.withMergeRequestsEnabled = $(select).data('withMergeRequestsEnabled');

    placeholder = "Search for project";
    if (this.includeGroups) {
      placeholder += " or group";
    }

    $(select).select2({
      placeholder: placeholder,
      minimumInputLength: 0,
      query: function (_this) {
        return function (query) {
          var finalCallback, projectsCallback;
          finalCallback = function finalCallback(projects) {
            var data;
            data = {
              results: projects
            };
            return query.callback(data);
          };
          if (_this.includeGroups) {
            projectsCallback = function projectsCallback(projects) {
              var groupsCallback;
              groupsCallback = function groupsCallback(groups) {
                var data;
                data = groups.concat(projects);
                return finalCallback(data);
              };
              return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].groups(query.term, {}, groupsCallback);
            };
          } else {
            projectsCallback = finalCallback;
          }
          if (_this.groupId) {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].groupProjects(_this.groupId, query.term, projectsCallback);
          } else {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].projects(query.term, {
              order_by: _this.orderBy,
              with_issues_enabled: _this.withIssuesEnabled,
              with_merge_requests_enabled: _this.withMergeRequestsEnabled,
              membership: !_this.allProjects
            }, projectsCallback);
          }
        };
      }(this),
      id: function id(project) {
        if (simpleFilter) return project.id;
        return JSON.stringify({
          name: project.name,
          url: project.web_url
        });
      },
      text: function text(project) {
        return project.name_with_namespace || project.name;
      },
      dropdownCssClass: "ajax-project-dropdown"
    });
    if (simpleFilter) return select;
    return new __WEBPACK_IMPORTED_MODULE_1__project_select_combo_button__["a" /* default */](select);
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./project_select_combo_button.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_accessor__ = __webpack_require__("./lib/utils/accessor.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var ProjectSelectComboButton = function () {
  function ProjectSelectComboButton(select) {
    _classCallCheck(this, ProjectSelectComboButton);

    this.projectSelectInput = $(select);
    this.newItemBtn = $('.new-project-item-link');
    this.resourceType = this.newItemBtn.data('type');
    this.resourceLabel = this.newItemBtn.data('label');
    this.formattedText = this.deriveTextVariants();
    this.groupId = this.projectSelectInput.data('groupId');
    this.bindEvents();
    this.initLocalStorage();
  }

  _createClass(ProjectSelectComboButton, [{
    key: 'bindEvents',
    value: function bindEvents() {
      var _this = this;

      this.projectSelectInput.siblings('.new-project-item-select-button').on('click', function (e) {
        return _this.openDropdown(e);
      });

      this.newItemBtn.on('click', function (e) {
        if (!_this.getProjectFromLocalStorage()) {
          e.preventDefault();
          _this.openDropdown(e);
        }
      });

      this.projectSelectInput.on('change', function () {
        return _this.selectProject();
      });
    }
  }, {
    key: 'initLocalStorage',
    value: function initLocalStorage() {
      var localStorageIsSafe = __WEBPACK_IMPORTED_MODULE_0__lib_utils_accessor__["a" /* default */].isLocalStorageAccessSafe();

      if (localStorageIsSafe) {
        this.localStorageKey = ['group', this.groupId, this.formattedText.localStorageItemType, 'recent-project'].join('-');
        this.setBtnTextFromLocalStorage();
      }
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'openDropdown',
    value: function openDropdown(event) {
      $(event.currentTarget).siblings('.project-item-select').select2('open');
    }
  }, {
    key: 'selectProject',
    value: function selectProject() {
      var selectedProjectData = JSON.parse(this.projectSelectInput.val());
      var projectUrl = selectedProjectData.url + '/' + this.projectSelectInput.data('relativePath');
      var projectName = selectedProjectData.name;

      var projectMeta = {
        url: projectUrl,
        name: projectName
      };

      this.setNewItemBtnAttributes(projectMeta);
      this.setProjectInLocalStorage(projectMeta);
    }
  }, {
    key: 'setBtnTextFromLocalStorage',
    value: function setBtnTextFromLocalStorage() {
      var cachedProjectData = this.getProjectFromLocalStorage();

      this.setNewItemBtnAttributes(cachedProjectData);
    }
  }, {
    key: 'setNewItemBtnAttributes',
    value: function setNewItemBtnAttributes(project) {
      if (project) {
        this.newItemBtn.attr('href', project.url);
        this.newItemBtn.text(this.formattedText.defaultTextPrefix + ' in ' + project.name);
      } else {
        this.newItemBtn.text('Select project to create ' + this.formattedText.presetTextSuffix);
      }
    }
  }, {
    key: 'getProjectFromLocalStorage',
    value: function getProjectFromLocalStorage() {
      var projectString = localStorage.getItem(this.localStorageKey);

      return JSON.parse(projectString);
    }
  }, {
    key: 'setProjectInLocalStorage',
    value: function setProjectInLocalStorage(projectMeta) {
      var projectString = JSON.stringify(projectMeta);

      localStorage.setItem(this.localStorageKey, projectString);
    }
  }, {
    key: 'deriveTextVariants',
    value: function deriveTextVariants() {
      var defaultTextPrefix = this.resourceLabel;

      // the trailing slice call depluralizes each of these strings (e.g. new-issues -> new-issue)
      var localStorageItemType = 'new-' + this.resourceType.split('_').join('-').slice(0, -1);
      var presetTextSuffix = this.resourceType.split('_').join(' ').slice(0, -1);

      return {
        localStorageItemType: localStorageItemType, // new-issue / new-merge-request
        defaultTextPrefix: defaultTextPrefix, // New issue / New merge request
        presetTextSuffix: presetTextSuffix // issue / merge request
      };
    }
  }]);

  return ProjectSelectComboButton;
}();

/* harmony default export */ __webpack_exports__["a"] = (ProjectSelectComboButton);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ })

},["./pages/groups/merge_requests/index.js"]);


// WEBPACK FOOTER //
// pages.groups.merge_requests.4b2ff0a4f9bbae6464c6.bundle.js